import {
  ModalRoot,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
  ActionLink,
} from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { PurchaseTermCallButtonWrapper } from 'shared/components/PurchaseTermCallButtonWrapper';
import { PurchaseTermDescriptionModal } from 'shared/components/PurchaseTermDescriptionModal';
import { NBSP } from 'shared/constants';
import { selectMainDiscountPromo } from 'shared/selectors/newObject';
import { IDescriptionDialog } from 'shared/types/purchaseTerm';

import { PurchaseTermsCallButton } from './PurchaseTermsCallButton';
import { PurchaseTermsCellContainer } from './PurchaseTermsCell';
import { PurchaseTermsPromoContainer } from './PurchaseTermsPromo';
import { trackModalShow } from './tracking';
import { PurchaseTermsModal } from '../../components/PurchaseTermsModal';
import { selectPurchaseTerms } from '../../selectors/purchaseTerms';

interface IPurchaseTermsModalContainerProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

// ts-unused-exports:disable-next-line
export const PurchaseTermsModalContainer: React.FC<IPurchaseTermsModalContainerProps> = ({ isOpen, setIsOpen }) => {
  const purchaseTerms = useSelector(selectPurchaseTerms);
  const promo = useSelector(selectMainDiscountPromo);

  const [activeDialog, setActiveDialog] = React.useState<IDescriptionDialog | null>(null);

  const onTermClick = React.useCallback((dialog: IDescriptionDialog) => {
    setActiveDialog(dialog);
  }, []);

  React.useEffect(() => {
    if (!purchaseTerms || !isOpen) {
      return;
    }

    trackModalShow({
      types: purchaseTerms.priceOptions.map(term => term.priceType),
      promoId: promo?.uniquePromoId,
      isDiscountPromo: promo && promo.promoType === 'discount',
    });
  }, [purchaseTerms, isOpen, promo]);

  React.useEffect(() => {
    if (!isOpen) {
      setActiveDialog(null);
    }
  }, [isOpen]);

  if (!purchaseTerms) {
    return null;
  }

  return (
    <ModalRoot open={isOpen} onOpenChange={setIsOpen}>
      <ModalContent>
        <ModalCloseButton title="Закрыть" size="XS" theme="fill_light" icon={<IconActionClose16 />} />
        {!activeDialog && (
          <ModalHeader>
            <ModalTitle>Способы покупки и{NBSP}цены</ModalTitle>
          </ModalHeader>
        )}

        <ModalBody>
          {activeDialog && (
            <PurchaseTermDescriptionModal
              imageUrl={activeDialog.imageUrl}
              description={activeDialog.description}
              title={activeDialog.title}
            />
          )}
          {!activeDialog && (
            <PurchaseTermsModal
              promo={<PurchaseTermsPromoContainer />}
              termsList={purchaseTerms.priceOptions.map((term, index) => (
                <PurchaseTermsCellContainer key={index} term={term} onClick={onTermClick} />
              ))}
            />
          )}
        </ModalBody>
        <ModalFooter>
          <PurchaseTermCallButtonWrapper>
            <PurchaseTermsCallButton modalType={activeDialog ? 'purchase_term_modal' : 'prices_modal'} />
            {activeDialog && (
              <ActionLink fontSize="M" onClick={() => setActiveDialog(null)}>
                Назад
              </ActionLink>
            )}
          </PurchaseTermCallButtonWrapper>
        </ModalFooter>
      </ModalContent>
    </ModalRoot>
  );
};
